import React from 'react'

function CapitalQuestion({title}) {
  return (
    <div>
        <h2 className="text-lg max-w-xs font-bold text-[#2F527B] my-7">
          {title} is the capital of
        </h2>
    </div>
  )
}

export default CapitalQuestion